import { useCallback, useEffect, useState } from 'react';

const read = (key: string) => {
  try {
    return window.sessionStorage.getItem(key) ?? undefined;
  } catch {
    return undefined;
  }
};

const write = (key: string, value: string | undefined) => {
  try {
    if (value === undefined) window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, value);
  } catch {
    // Storage can be blocked (private mode, disabled site data); the value then lasts for the page.
  }
};

export const useSessionValue = (key: string) => {
  const [value, setValue] = useState<string>();

  useEffect(() => setValue(read(key)), [key]);

  const update = useCallback(
    (next: string | undefined) => {
      write(key, next);
      setValue(next);
    },
    [key]
  );

  return [value, update] as const;
};
